// The coupon service stores validFrom/expiredAT as naive LocalDateTime values and its
// container runs UTC, so an offset-less timestamp on the wire is a UTC wall clock.
// Reading one as browser-local moves the value by the operator's offset every time it
// is read back and saved, which is what LISA-333 and LISA-560 both came from.
const HAS_OFFSET = /[zZ]|[+-]\d{2}:?\d{2}$/;

// This is the one place allowed to parse a backend timestamp directly: the offset is
// guaranteed present by the time Date sees it, so the offset-less hazard cannot arise.
// Everything else goes through normalizeDate/formatDate, which delegate to this.
export function parseBackendTimestamp(value: string): Date {
  return new Date(HAS_OFFSET.test(value) ? value : `${value}Z`);
}

// Send the instant the operator actually picked. This has to be the exact inverse of
// parseBackendTimestamp: any asymmetry between the two walks a stored value in one
// direction each time someone opens a form and saves it.
export function toBackendTimestamp(value: Date | string): string {
  return new Date(value).toISOString();
}

// End of the following day in the operator's own timezone. Coupons are dated by the day
// they should cover, so defaulting to the current clock would expire one partway through
// its last day.
export function defaultCouponExpiry(from: Date): Date {
  const date = new Date(from);
  date.setDate(date.getDate() + 1);
  date.setHours(23, 59, 0, 0);
  return date;
}
